



  // import { createApp } from 'formSurveyApp/vue3'
  // import FormList from 'formSurveyApp/FormList';
  
import { createApp } from 'conversationsApp/vue3'
  import NewMessageModal from 'conversationsApp/NewMessageModal';
  import { useEmitter } from '../../composition/useEmitter'
  import { defineComponent } from '@vue/composition-api'
  let conversationNewMessageComponent: any = {}
  
  export default defineComponent({
    watch: {
      '$route': function (id) {
        this.mountConversationsMessageModal()
      },
    },
    mounted() {
      this.mountConversationsMessageModal()
    },
    methods: {
      mountConversationsMessageModal() {
        if (conversationNewMessageComponent.unmount) conversationNewMessageComponent?.unmount()
        const route = this.$route
        const router = this.$router
        const emitter = useEmitter()
        const user = this.$store.getters['user/get']
        const store = this.$store
        conversationNewMessageComponent = createApp(NewMessageModal, {
          route,
          router,
          emitter,
          user,
          store
        });
        conversationNewMessageComponent.mount('#conversation-new-message-modal');
      },
    }
  })
  